import {Injectable} from '@angular/core';
import {BaseOPEService} from "./BaseOPEService";
import {DelDeviceTypeCB} from "../../ope/device-type/DelDeviceTypeCB";
import {PutDeviceCB} from "../../ope/device/PutDeviceCB";
import {GetDeviceCB} from "../../ope/device/GetDeviceCB";
import {GetDevicesCB} from "../../ope/device/GetDevicesOpe";
import {GetDevicesMetricInstancesCB} from "../../ope/device/GetDevicesMetricInstancesCB";
import {ResetDeviceFromModelCB} from "../../ope/device/ResetDeviceFromModelCB";

@Injectable({
  providedIn: 'root'
})
export class DeviceOpeService extends BaseOPEService {

  public getDevice(cb: GetDeviceCB): Promise<any> {
    return this.execOPE(cb);
  }

  public getDevices(cb: GetDevicesCB): Promise<any> {
    return this.execOPE(cb);
  }

  public getDevicesMetricInstances(cb: GetDevicesMetricInstancesCB): Promise<any> {
    return this.execOPE(cb);
  }

  public putDevice(cb: PutDeviceCB): Promise<any> {
    return this.execOPE(cb);
  }

  public delDevice(cb: DelDeviceTypeCB): Promise<any> {
    return this.execOPE(cb);
  }

  public resetDeviceFromModel(cb: ResetDeviceFromModelCB): Promise<any> {
    return this.execOPE(cb);
  }

}
